import angular from "angular";

import Assert from "tbAssert";

const initMobileMaxWidth = 767;

const mLogSvc = new WeakMap();
const mWindowSvc = new WeakMap();
const mMobileViewQuery = new WeakMap();
const mMobileMaxWidth = new WeakMap();

class MobileViewDetectorService {
    constructor($log, $window, $rootScope) {
        Assert.StrictAssert($log != null, "Assertion Failure: Missing Log Service Dependency");
        Assert.StrictAssert($window != null, "Assertion Failure: Missing Window Service Dependency");
        Assert.StrictAssert($rootScope != null, "Assertion Failure: Missing Root Scope Dependency");

        mLogSvc.set(this, $log);
        mWindowSvc.set(this, $window);

        this._listenerActive = false;
        this._isMobileView = false;

        this.mobileMaxWidth = initMobileMaxWidth;

        $rootScope.$on("$destroy", () => {
            this.close();
        });
    }

    toString() {
        return "MobileViewDetector";
    }

    get mobileMaxWidth() {
        return mMobileMaxWidth.get(this);
    }

    set mobileMaxWidth(maxWidth) {
        if ((Number.isInteger(maxWidth)) && (maxWidth > 0)) {
            this.close();
            mMobileMaxWidth.set(this, maxWidth);
            let mobileViewQuery = mWindowSvc.get(this).matchMedia(`(max-width: ${maxWidth}px)`);
            mMobileViewQuery.set(this, mobileViewQuery);
            this._setup();
        }
        else {
            throw new Error("Mobile View Detector: Mobile Max Width Parameter Must Be An Integer Greater Than 0");
        }
    }

    _handleMobileViewChange(mobileViewMediaQuery) {
        if (mobileViewMediaQuery.matches) {
            this._isMobileView = true;
            mLogSvc.get(this).debug("Mobile View Detector Change Handler: Set Mobile View To True.");
        }
        else {
            this._isMobileView = false;
            mLogSvc.get(this).debug("Mobile View Detector Change Handler: Set Mobile View To False.");
        }
    }

    get isViewMobile() {
        if (!this._listenerActive) {
            mLogSvc.get(this).warn("Mobile View Detector: Not Listening For Screen Changes And May Report Incorrect Results.");
        }

        return this._isMobileView;
    }

    _setup() {
        if (this._listenerActive !== true) {
            let mobileViewQuery = mMobileViewQuery.get(this);
            mobileViewQuery.addListener((mvQuery) => { this._handleMobileViewChange(mvQuery); });
            this._handleMobileViewChange(mobileViewQuery);
            this._listenerActive = true;

            mLogSvc.get(this).debug(`Mobile View Detector: Listening For View Size Changes (Mobile Max Width: ${this.mobileMaxWidth}px)`);
        }
        else {
            mLogSvc.get(this).debug("Mobile View Detector: Ignoring Request To Start Listening For View Size Changes: Already Listening.");
        }
    }

    close() {
        if (this._listenerActive === true) {
            let mobileViewQuery = mMobileViewQuery.get(this);
            mobileViewQuery.removeListener(this._handleMobileViewChange);
            this._listenerActive = false;

            mLogSvc.get(this).debug(`Mobile View Detector: Stopped Listening For View Size Changes (Mobile Max Width: ${this.mobileMaxWidth}px)`);
        }
        else {
            mLogSvc.get(this).debug("Mobile View Detector: Ignoring Request To Stop Listening For View Size Changes: Not Currently Listening");
        }
    }
}

MobileViewDetectorService.$inject = [ "$log", "$window", "$rootScope" ];

export default angular
    .module("trackerbase-app.services.mobile-view-detector", [
    ])
    .service("MobileViewDetector", MobileViewDetectorService)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/services/MobileViewDetectorService.js
// module id = MIZK
// module chunks = 1